/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { WoundOrderViewModel } from './WoundOrderViewModel'; 

export function getWoundOrderOptions(woundId: string, onSuccess?: (result?: WoundOrderViewModel) => void) {
	return queryOptions({
		queryKey: ['wound-order', woundId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/woundmanagement/queries/getwoundorder/' + woundId;
			const resp = await axios.get<WoundOrderViewModel | null>(url);
	        const result = resp.data ?? null;
	        onSuccess?.(result ?? undefined);
	        return result;
        },
        select: (x) => x ?? undefined,
        enabled: Boolean(woundId)
	});
}